module.exports = __webpack_public_path__ + "954edc66831b030ee3c00c63baaaf998.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-12.png
// module id = 2276
// module chunks = 0